import { PermitMap } from '@mvrb-frontend/shared-ui';

export const Boards = [
  {
    value: 'Mackenzie Valley Environmental Impact Review Board (MVEIRB)',
    label: 'Mackenzie Valley Environmental Impact Review Board (MVEIRB)',
  },
  { value: 'Board 1', label: 'Board 1' },
  { value: 'Board 2', label: 'Board 2' },
  { value: 'Board 3', label: 'Board 3' },
];

export const Proponents = [
  { value: 'Blachford Lake Lodge', label: 'Blachford Lake Lodge' },
  { value: 'Proponent 1', label: 'Proponent 1' },
  { value: 'Proponent 2', label: 'Proponent 2' },
  { value: 'Proponent 3', label: 'Proponent 3' },
];

export const ProponentResponses = [
  { value: 'Staff member 1', label: 'Staff member 1' },
  { value: 'Staff member 2', label: 'Staff member 2' },
];

export const Permits = Object.keys(PermitMap).map(key => ({ value: key, label: PermitMap[key] }));

export const Activities = [
  { value: 'Activity 1', label: 'Activity 1' },
  { value: 'Activity 2', label: 'Activity 2' },
  { value: 'Activity 3', label: 'Activity 3' },
];

export const StaffContacts = [
  { value: 'Contact 1', label: 'Contact 1' },
  { value: 'Contact 2', label: 'Contact 2' },
];

export const ProponentPrimaryContact = [
  { value: 'Contact 1', label: 'Contact 1' },
  { value: 'Contact 2', label: 'Contact 2' },
];

export const PublicReviews = [
  { value: 'Option 1', label: 'Option 1' },
  { value: 'Option 2', label: 'Option 2' },
  { value: 'Option 3', label: 'Option 3' },
];

export const Types = [
  { value: 'All', label: 'All' },
  { value: 'Review', label: 'Item for Review' },
  { value: 'IR', label: 'Information Request' },
];

export const Statuses = [
  { value: 'All', label: 'All' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Active', label: 'Active' },
  { value: 'Review', label: 'Review' },
  { value: 'Completed', label: 'Completed' },
];

export const PublicStatuses = [
  { value: 'All', label: 'All' },
  { value: 'Active', label: 'Active' },
  { value: 'Completed', label: 'Completed' },
];
export const StaffStatuses = [
  { value: 'All', label: 'All' },
  { value: 'Draft', label: 'Draft' },
  { value: 'Active', label: 'Active' },
  { value: 'Completed', label: 'Completed' },
];

export const DateRanges = [
  { value: 'All', label: 'All' },
  { value: '1', label: 'Last 30 Days' },
  { value: '6', label: 'Last 6 months' },
  { value: '12', label: 'Last 12 months' },
];

export enum ReviewStatusEnum {
  DRAFT = 'Draft',
  ACTIVE = 'Active',
  REVIEW = 'Review',
  COMPLETED = 'Completed',
}

export enum ReviewStatusPaginationEnum {
  DRAFT = 'Draft',
  ACTIVE = 'Active',
  REVIEW = 'Review',
  COMPLETED = 'Completed',
  ALL = 'All',
}

export enum ReviewTypeEnum {
  REVIEW = 'Review',
  IR = 'IR',
  ALL = 'All',
}

export enum CommentStatusEnum {
  DRAFT = 'draft',
  PUBLISHED = 'published',
}

export enum CommentTypeEnum {
  Default = 'default',
  Audio = 'audio',
}

export enum UserTypeEnum {
  Staff = 'Staff',
  User = 'User',
  Admin = 'Admin',
}

export enum UploadType {
  CommentAttachment = 'CommentAttachment',
  ResponseAttachment = 'ResponseAttachment',
  Transcript = 'Transcript',
  Audio = 'Audio',
  File = 'File',
}

/**
 * Users
 */
export const Prefixes = [
  { value: 'Mr.', label: 'Mr.' },
  { value: 'Mrs.', label: 'Mrs.' },
  { value: 'Ms.', label: 'Ms.' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Chief', label: 'Chief' },
];

export const Provinces = [
  { value: 'Alberta', label: 'Alberta' },
  { value: 'British Columbia', label: 'British Columbia' },
  { value: 'Manitoba', label: 'Manitoba' },
  { value: 'New Brunswick', label: 'New Brunswick' },
  { value: 'Newfoundland and Labrador', label: 'Newfoundland and Labrador' },
  { value: 'Northwest Territories', label: 'Northwest Territories' },
  { value: 'Nova Scotia', label: 'Nova Scotia' },
  { value: 'Nunavut', label: 'Nunavut' },
  { value: 'Ontario', label: 'Ontario' },
  { value: 'Prince Edward Island', label: 'Prince Edward Island' },
  { value: 'Quebec', label: 'Quebec' },
  { value: 'Saskatchewan', label: 'Saskatchewan' },
  { value: 'Yukon', label: 'Yukon' },
];

export const SystemManagementMenuItems = [
  { value: 'users', label: 'Users' },
  { value: 'organizations', label: 'Organizations' },
  { value: 'distribution-lists', label: 'Distribution Lists' },
  { value: 'review-topics', label: 'Review Topics' },
  { value: 'file-uploads', label: 'File Uploads' },
  { value: 'user-manual', label: 'User Manual' },
  { value: 'admin', label: 'Admin' },
  { value: 'engagement', label: 'Engagement' },
  { value: 'news-letter', label: 'Newsletter' },
];

export const UserProfileMenuItems = [
  { value: 'userInformation', label: 'User Information' },
  { value: 'distribution-list', label: 'Distribution List' },
];

export enum UserProfileMode {
  AddByStaff,
  EditByStaff,
  EditOwn,
}

export const AUTOCOMPLETE_DEFAULT_PAGE_SIZE = 100;
